// extracted by mini-css-extract-plugin
export default {"status":"Status_status__Yh7gA","offline":"Status_offline__mLx5+","online":"Status_online__Ntqsx"};